import type { PolicySection } from '../../types/policy';

/** Shared "right to modify" clause appended to every policy page. */
export function changesSection(policyName: string, heading = 'Changes to this policy'): PolicySection {
  return {
    id: 'changes',
    heading,
    blocks: [
      `We reserve the right, at our sole discretion, to change, modify, add or remove any part of this ${policyName} at any time, without prior notice. Changes take effect immediately when posted on this page with an updated "Last updated" date. The version in effect on the date of your order applies to that order. Your continued use of this website or purchase of our products after changes are posted constitutes your acceptance of the revised ${policyName}. It is your responsibility to review this page periodically.`,
    ],
  };
}
